import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { supabase } from '../lib/supabase';

const PaymentCancel: React.FC = () => {
  useEffect(() => {
    const cancelPendingRegistrations = async () => {
      const paymentReference = sessionStorage.getItem('pendingPaymentReference');
      if (!paymentReference) return;

      // Mark the abandoned registration batch as cancelled so it doesn't
      // linger as "unpaid" on the user's dashboard
      const { error } = await supabase
        .from('registrations')
        .update({ status: 'cancelled', payment_status: 'failed' })
        .eq('payment_reference', paymentReference)
        .eq('payment_status', 'pending');

      if (error) {
        console.error('Failed to cancel pending registrations:', error);
      }

      sessionStorage.removeItem('pendingRegistrationId');
      sessionStorage.removeItem('pendingPaymentReference');
    };

    cancelPendingRegistrations();
  }, []);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg shadow-lg p-8 max-w-md w-full text-center">
        <FontAwesomeIcon icon={faTimesCircle} className="text-4xl text-orange-500 mb-4" />
        <h1 className="text-2xl font-bold text-gray-800 mb-2">Payment Cancelled</h1>
        <p className="text-gray-600 mb-6">
          Your payment was cancelled. Your registration has not been completed.
        </p>
        <p className="text-sm text-gray-500 mb-6">
          You can try again or contact the event organizer if you need assistance.
        </p>
        <div className="space-y-3">
          <Link 
            to="/events" 
            className="block w-full bg-primary text-white py-3 px-6 rounded-lg hover:bg-primary-dark transition-colors"
          >
            <FontAwesomeIcon icon={faArrowLeft} className="mr-2" />
            Back to Events
          </Link>
          <Link 
            to="/" 
            className="block w-full border border-gray-300 text-gray-700 py-3 px-6 rounded-lg hover:bg-gray-50 transition-colors"
          >
            Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancel;
